import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {BackendApi, localhost} from '../config/backend-api';
import {Pending} from '../model/questionnaires/Pending';
import {Store} from '@ngrx/store';
import {AppState} from '../store/app.states';
import {GetPendings} from '../store/actions/patient.actions';
import {NameAndDaysQuestionnaire} from '../model/user/NameAndDaysQuestionnaire';

@Injectable({
  providedIn: 'root'
})
export class QuestionnaireService {

  constructor(private httpClient: HttpClient,
              private store: Store<AppState>,
              private router: Router,
              private route: ActivatedRoute) { }

  sendForm(qForm, type: string, uuid: string) {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.QUESTIONNAIRE_SEND + '/' + type + '/' + uuid, qForm, {responseType: 'text', observe: 'response'})
      .subscribe(d => {
      console.log(d);
      if (d.status === 200) {
        if (type.includes('clinical')) {
          const destination = JSON.parse(sessionStorage.getItem('destination'));
          // tslint:disable-next-line:only-arrow-functions
          this.router.navigateByUrl('/success').then(() => setTimeout(function() {
            location.replace(destination);
          }, 2000));
        } else {
          this.store.dispatch(new GetPendings());
          // tslint:disable-next-line:only-arrow-functions
          this.router.navigateByUrl('/success').then(() => setTimeout(function() {
            location.replace('/landing');
          }, 2000));
        }
        }
      },
      error => {
        // tslint:disable-next-line:only-arrow-functions
        if (type.includes('clinical')) {
          const destination = JSON.parse(sessionStorage.getItem('destination'));
          // tslint:disable-next-line:only-arrow-functions
          this.router.navigateByUrl('/success').then(() => setTimeout(function() {
            location.replace(destination);
          }, 3000));
        } else {
          this.store.dispatch(new GetPendings());
          // tslint:disable-next-line:only-arrow-functions
          this.router.navigateByUrl('/success').then(() => setTimeout(function() {
            location.replace('/landing');
          }, 3000));
        }
        console.log(error);
      });
  }

  sendFormGradimento(qForm, type: string) {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.QUESTIONNAIRE_SEND + '/' + type , qForm, {responseType: 'text', observe: 'response'})
    .subscribe(d => {
      console.log(d);
      if (d.status === 200) {
          // tslint:disable-next-line:only-arrow-functions
          this.router.navigateByUrl('/success').then(() => setTimeout(function() {
            location.replace('/landing');
          }, 2000));
        }
      },
      error => {
        console.log(error);
      });
  }

  checkCompiledGradimento(ssn: string) {
    return this.httpClient.get<boolean>(localhost + BackendApi.CHECK_GRADIMENTO_ALREADY_DONE + '/' + ssn, {responseType: 'json'});
  }

  setQuestionnaires(patientSSN: string, questionnaires: string[]) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.SET_QUESTIONNAIRES + doctorID + '/' + patientSSN, questionnaires, {responseType: 'text', observe: 'response'});
  }

  removeQuestionnaire(patientSSN: string, questionnaire: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.REMOVE_QUESTIONNAIRE + doctorID + '/' + patientSSN, questionnaire, {responseType: 'text', observe: 'response'});
  }

  createAndSend(questionnaire, patientSSN) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    return this.httpClient
      .post(localhost + BackendApi.CREATE_AND_SEND_QUESTIONNAIRE + questionnaire + '/' + doctorID + '/' + patientSSN, null,
        {responseType: 'text', observe: 'response'});
  }

  getAllPendings() {
    const patientSSN = JSON.parse(localStorage.getItem('user')).ssn;
    return this.httpClient.get<Pending[]>(localhost + BackendApi.GET_ALL_PENDING + patientSSN);
  }

  getAllClinicalPendings(doctorID, patientSSN, type) {
    return this.httpClient.get<Pending[]>(localhost + BackendApi.GET_ALL_CLINICAL_PENDING + doctorID + '/' + patientSSN + '/' + type);
  }

  addJob(type: string, patientSSN: string, timer) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    console.log('Timer: ' + timer);
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.ADD_JOB + doctorID + '/' + patientSSN + '/' + type, timer, {responseType: 'text', observe: 'response'});
  }

  killJob(type: string, patientSSN: string) {
    const doctorID = JSON.parse(localStorage.getItem('doctorID'));
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.KILL_JOB + doctorID + '/' + patientSSN + '/' + type, null, {responseType: 'text', observe: 'response'});
  }

  getAllFrequencyQuestionnaires(patientSSN: string) {
    return this.httpClient.get<NameAndDaysQuestionnaire[]>(localhost + BackendApi.GET_ALL_FREQUENCY_QUESTIONNAIRES + patientSSN);
  }
}
